import React, { useContext } from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { Box, Typography } from "@mui/material";
const Footer = () => {
  return (
    <>
      <Box
        sx={{ textAlign: "center", bgcolor: "orange", color: "black", p: 3 }}
      >
        <Box
          sx={{
            my: 3,
            "& svg": {
              fontSize: "60px",
              cursor: "pointer",
              mr: 2,
            },
            "& svg:hover": {
              color: "goldenrod",
              transform: "translateX(5px)",
              transition: "all 400ms",
            },
          }}
        >
          {/* icons */}
          <InstagramIcon onClick = {() => {
                    window.location.href = "https://www.instagram.com/ali_sahil0"
                  }}
          ></InstagramIcon>
          <TwitterIcon onClick = {() => {
                    window.location.href = "/"
                  }}>
          </TwitterIcon> 
          <GitHubIcon onClick = {() => {
                    window.location.href = "https://github.com/Parvej0Ali"
                  }}
          ></GitHubIcon> 
          <YouTubeIcon onClick = {() => {
                    window.location.href = "https://www.youtube.com/parvejali3952"
                  }}
          ></YouTubeIcon>
        </Box>
        <Typography
          variant="h5"
          sx={{
            "@media (max-width:600px)": {
              fontSize: "1rem",
            },
          }}
        >
          All Rights Reserved &copy; Parvej Ali
        </Typography>
      </Box>
    </>
  );
};

export default Footer;
